import { render, staticRenderFns } from "./LegacyNavigation.vue?vue&type=template&id=08597d84"
import script from "./LegacyNavigation.vue?vue&type=script&lang=js"
export * from "./LegacyNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports